<template>
  <div id="app" :class="{authPage: isAuth}" >
    <div v-if="isAuth">
      <headMenu/>
      <div class="global">
        <div class="left"><leftMenu/></div>
        <div class="right"><router-view/></div>
      </div>
      <foot/>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import { getBuisnessToken } from '@/libs/util'
import headMenu from '@/components/menu/headMenu.vue'
import leftMenu from '@/components/menu/leftMenu.vue'
import foot from '@/components/foot.vue'
export default {
  name: 'App',
  created() {
    this.normalizeExamShareRoute()
    const buisnessToken = getBuisnessToken();
    if (buisnessToken === false && !this.isExamShareRoute()) {
      this.$router.replace({ name: "Login" });
    }
  },
  data() {
    return {
      isAuth: false,
    }
  },
  watch: {
    '$route.path': function () {
      this.isAuth = !this.isPublicRoute()
    }
  },
  components: {
    headMenu,
    leftMenu,
    foot
  },
  mounted() {
    this.normalizeExamShareRoute()
    this.isAuth = !this.isPublicRoute()
    const buisnessToken = getBuisnessToken();
    if (buisnessToken === false && !this.isExamShareRoute()) {
      this.$router.replace({ name: "Login" });
    }
  },
  methods: {
    normalizeExamShareRoute() {
      const location = typeof window !== 'undefined' ? window.location : null
      const hashPath = location && location.hash
        ? location.hash.replace(/^#/, '').split('?')[0].replace(/\/+$/, '')
        : ''

      // Hash links are already in Vue Router's native format. Replacing the
      // route before Vue finishes parsing would discard the token query.
      if (hashPath === '/examShare') {
        return
      }

      if (!this.isExamShareRoute() || (this.$route && this.$route.path === '/examShare')) {
        return
      }

      const routeQuery = (this.$route && this.$route.query) || {}
      const tokenMatch = location && location.search
        ? location.search.match(/[?&]token=([^&]+)/)
        : null
      const query = Object.assign({}, routeQuery)
      if (!query.token && tokenMatch) {
        query.token = decodeURIComponent(tokenMatch[1])
      }
      this.$router.replace({ name: 'ExamShare', query })
    },
    // During a hash-router refresh, $route.path can briefly be "/".
    isExamShareRoute() {
      const routePath = this.$route && this.$route.path
      const location = typeof window !== 'undefined' ? window.location : null
      const hashPath = location && location.hash
        ? location.hash.replace(/^#/, '').split('?')[0]
        : ''
      const paths = [routePath, location && location.pathname, hashPath]
        .filter(Boolean)
        .map(path => path.replace(/\/+$/, '') || '/')

      return paths.some(path => path === '/examShare' || path.endsWith('/examShare'))
    },
    isPublicRoute() {
      const routePath = this.$route && this.$route.path
      return this.isExamShareRoute() || ['/login', '/register', '/forgetPwd'].includes(routePath)
    }
  }
}
</script>
<style>
.ivu-layout{
  background: #fff!important;
}
.header-bar{
  box-shadow: 10px 10px 20px #f5f5f5;
}
</style>

<style lang="less">

.main .content-wrapper{
  padding:0;
}
.size{
  width: 100%;
  height: 100%;
}
.authPage {
  height: auto!important;
}
html,body{
  .size;
  margin: 0;
  padding: 0;
}
#app {
  .size;
  background: #f1f1f1;
  // overflow-x: hidden;
}
.global {
  width: 88%;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
  .left { 
  }
  .right {
    width: 83%;
  }
}
.ivu-layout-header {
    // padding: 0 2.976vw;
    height: 24px!important;
    line-height: 24px!important;
}
.sider-trigger-a {
    // padding: 0 2.976vw;
    height: 50px!important;
    line-height: 50px!important;
    margin-top: 6px;
}
.business .ivu-table-header thead tr th {
  background-color: #2db7f5!important;
  color: #fff!important;
}
.ivu-table-border tr td .ivu-table-cell {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  span{
    line-height: 1.8;
    
  }
}
.search-width .ivu-input-wrapper{
  width: 12vw;
}
.search-width .ivu-select{
  width: 12vw;
}
.dangerous .ivu-poptip-rel{
text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box!important;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ivu-modal{
  width: 50vw !important;
}
.hiddenDanger{
height: 4vh;
}
.hiddenDanger p{
  width: 23vw;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box!important;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.hiddenDanger .ivu-select-single .ivu-select-selection .ivu-select-placeholder{
  color:#515a6e!important
}
.allSelect .ivu-select-single .ivu-select-selection .ivu-select-placeholder{
  color:#515a6e!important
}

.main-content td button:nth-child(n + 2),
.main-content td a:nth-child(n + 2),
.main-content .ivu-col button:nth-child(n + 2),
.main-content .ivu-col a:nth-child(n + 2) {
  margin-left: 5px;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item{
  padding-left: 3vw!important;
}
</style>
